<template>
  <div>
      <div class="flexSpaceBetween" style="margin-top: 50px; flex-wrap: wrap;">

          <div style="width: 30%;">

              <div style="text-align: center; width: 100%;">
                <img src="https://raizzoncdn.b-cdn.net/home/new/time.png" style="max-width: 150px;" width="100%" alt="">
                <h2>Fast turn around</h2>
                <span>
                  Our clients love us for our fast turn around time. We love to go above and beyond to meet the deadlines.
                </span>
              </div>              
          </div>

          <div style="width: 30%;">
              <div style="text-align: center; width: 100%;">
                <img src="https://raizzoncdn.b-cdn.net/home/new/price-tag.png" style="max-width: 150px;" width="100%" alt="">
                <h2>For really good price</h2>
                <span>
                  We have always tried to keep our billable hourly charges to the lowest by optimizing our resources and skills to the fullest potentials.
                </span>
              </div>
          </div>

          <div style="width: 30%;">
            <div style="text-align: center; width: 100%;">              
              <img src="https://raizzoncdn.b-cdn.net/home/new/help.png" style="max-width: 150px;" width="100%" alt="">
              <h2>Amazing support</h2>
              <span>
                In the core we believe ourselves as a integral part of our client's team, hence their is no way we could keep our client hanging in need of support or consultation.
              </span>
            </div>
          </div>
          
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Section2.vue